import script from "./RegisterRequestListView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegisterRequestListView.vue?vue&type=script&lang=ts&setup=true"

import "./RegisterRequestListView.vue?vue&type=style&index=0&id=7876ef43&lang=scss"

const __exports__ = script;

export default __exports__